import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-vip-crown-line text-2xl text-accent-500"></i>
              </div>
              <span className="text-lg font-bold font-heading">皇冠体育</span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              亚洲领先的专业体育竞技平台，为超过500万用户提供安全、公正、便捷的体育博彩服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">赛事分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-white/60 hover:text-accent-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-white/60 hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-white/60 hover:text-accent-400 transition-colors">关于我们</Link></li>
              <li><Link to="/category/football" className="text-sm text-white/60 hover:text-accent-400 transition-colors">足球赛事</Link></li>
              <li><Link to="/category/basketball" className="text-sm text-white/60 hover:text-accent-400 transition-colors">篮球赛事</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-customer-service-line text-accent-500"></i>
                <span>24小时在线客服</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-mail-line text-accent-500"></i>
                <span>service@huangguan-sports.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-phone-line text-accent-500"></i>
                <span>+852-3008-8888</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 皇冠体育 版权所有。本平台仅供18岁以上用户使用，请理性投注。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-white/40 hover:text-accent-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-white/40 hover:text-accent-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-white/40 hover:text-accent-400 transition-colors" rel="nofollow">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}